import React, { createContext, useContext, useMemo, useCallback } from "react";
import ar from "@/i18n/ar.json";
import en from "@/i18n/en.json";

const DICTIONARIES = { ar, en };

export const SUPPORTED_LANGS = ["ar", "en"];
export const DEFAULT_LANG = "ar";

const I18nContext = createContext({
  lang: DEFAULT_LANG,
  t: (key) => key,
});

function resolvePath(obj, path) {
  return path
    .split(".")
    .reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), obj);
}

export function I18nProvider({ lang, children }) {
  const activeLang = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
  const dict = DICTIONARIES[activeLang];

  const t = useCallback(
    (key, fallback) => {
      const value = resolvePath(dict, key);
      if (typeof value === "string") return value;
      const fb = resolvePath(DICTIONARIES[DEFAULT_LANG], key);
      if (typeof fb === "string") return fb;
      return fallback !== undefined ? fallback : key;
    },
    [dict],
  );

  const value = useMemo(() => ({ lang: activeLang, t }), [activeLang, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export function useT() {
  return useContext(I18nContext).t;
}
